'use client';
import React, { useEffect } from 'react';

import { Alert, Snackbar } from '@mui/material';
import { useAlerts } from '@/providers/alerts';
import { useSearchParams } from 'next/navigation';
import { array } from 'zod';

interface ErrorNotice {
  message: string;
  code: string;
  listId?: string;
}

const Toast: React.FC = () => {
  const searchParams = useSearchParams();
  const message = searchParams.get('message');
  const messageType = searchParams.get('message-type');
  const errors = searchParams.get('errors');
  const { alerts, setAlerts } = useAlerts();

  // useEffect(() => {
  //   if (message) {
  //     const alertType = messageType as 'success' | 'info' | 'error' | 'warning';
  //     setAlerts([{ type: alertType, message: message, duration: 6000 }]);
  //   }
  //   if (errors) {
  //     const errorsArray = errors ? JSON.parse(errors) as ErrorNotice[] : [];
  //     errorsArray.forEach((error) => {
  //       setAlerts([{ type: 'error', message: error.message, duration: 6000 }]);
  //     });
  //   }
  // }, [searchParams, setAlerts]);
  // console.log('alerts', alerts);
  return (
    <>
      {alerts.map((alert, index) => (
        <Snackbar
          key={index}
          open={alerts.length > 0}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={alert.duration ? +alert.duration : 5000}
          onClose={() =>
            setAlerts((val) => [
              ...val.slice(0, index),
              ...val.slice(index + 1)
            ])
          }
        >
          <Alert
            key={index}
            icon={false}
            severity={alert.type}
            onClose={() => setAlerts(alerts.filter((a) => a !== alert))}
            sx={{ flexDirection: 'row' }}
          >
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default Toast;
